import React from "react";
import PageShell from "@/components/layout/PageShell";
import SubHero from "@/components/layout/SubHero";

const sections = [
  ["Information saved", "When you create an APOS account, we save the account information and assessment data needed to keep your profile and results available. If you later use Companion, your check-ins, plans, progress, calendar activity, and Companion history can be connected to the same profile. Information submitted through the 1-to-1 coaching form is delivered to FORR Health by email."],
  ["How it is used", "Your information is used to provide your assessment, personalized results, saved profile, account support, product improvement, future Companion access, and responses to coaching enquiries. Early-access emails are used to notify you about Companion availability."],
  ["Your choices", "You can unsubscribe from early-access emails at any time. You can also request deletion of your account, assessment results, Companion waitlist email, coaching enquiry, and associated saved information."],
];

const Privacy = () => (
  <PageShell>
    <SubHero breadcrumb={[{ label: "Home", to: "/" }, { label: "Privacy" }]} overline="Privacy" headline="Your information," headlineAccent="your choice." lead="APOS saves information so your assessment results and future Companion profile remain available to you." />
    <section className="py-16 sm:py-24">
      <div className="mx-auto max-w-3xl px-6 sm:px-10">
        <div className="grid gap-4">
          {sections.map(([title, body]) => (
            <article key={title} className="rounded-[22px] p-7 forr-surface" style={{ border: "1px solid var(--forr-line)" }}>
              <h2 className="font-display text-2xl forr-text-ink">{title}</h2>
              <p className="mt-3 text-sm leading-relaxed forr-text-soft">{body}</p>
            </article>
          ))}
        </div>
        <div className="mt-8 rounded-[22px] p-7 forr-panel-action">
          <h2 className="font-display text-2xl forr-text-ink">Request deletion</h2>
          <p className="mt-3 text-sm leading-relaxed forr-text-soft">Email <a href="mailto:forrhealth.0@gmail.com" className="font-semibold forr-text-teal-deep">forrhealth.0@gmail.com</a> from the address connected to your account, waitlist entry, or coaching enquiry and ask us to delete your information.</p>
        </div>
      </div>
    </section>
  </PageShell>
);

export default Privacy;
